import React, { useEffect, useRef, useState } from "react";
import {
  capitalizeFirstLetter,
  getColor,
  getTextColor,
  stopEventPropagation,
} from "../../../utiles/helpers";
import CloseButton from "../../../assets/icon/CloseIcon";
import CancelButton from "../../common/button/CancelButton";

import checkNetworkStatus from "../../common/networkStatus/CheckNetworkStatus";
import useErrorHandle from "../../../constant/errorHandling/useErrorHandle";
import { disableModuleAPI, enableModuleAPI, getModules, getStoreModules, viewCustomer } from "../../../services/apiServices";
import "../../../styles/customer.css";
import StoreProfileData from "./StoreProfileData";
import AllModules from "./AllModules";
import StoreSetting from "./StoreSetting";

const ViewStore = ({ data, onClose }) => {
  const [activeTab, setActiveTab] = useState("profile");
  const [isViewData, setViewData] = useState([]);
  const [getModule,setGetModule]=useState([])
  const [storeModules ,setStoreModules] =useState([]);
  const [istLoading, setLoading] = useState([]);
  const renderContent = () => {
    switch (activeTab) {
      case "profile":
        return (
          <StoreProfileData
          isStore={data}
            data={isViewData}
            isLoading={istLoading}
            fetcViewMembers={fetcViewMembers}
          />    );
      case "module":
          return(
            <AllModules
            isStore={data}
            data={getModule}
            storeModules={storeModules}
            onModule={handleonModule}
            />
          );
      case "settings":
          return(
            <StoreSetting
            isStore={data}
            />
          )    

      default:
        return <DashboardData />;
    }
  };
  const handleError = useErrorHandle();
  const fetcViewMembers = async () => {
    checkNetworkStatus();
    setLoading(true);
    const payload = { customerid: data?._id || " " };
    try {
      const response = await viewCustomer(payload);
      setViewData(response.results);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleonModule = async (body, status) => {
    if (status === "ACTIVE") {
      await enableModuleAPI(body);
    } else {
      await disableModuleAPI(body);
    }
  };
  

  const handleGetModules=async()=>{
    checkNetworkStatus();
    try{
      const response = await getModules();
      setGetModule(response?.results)
    }
    catch (error){
      handleError(error);
    }
  }

  const handleStoreModules=async()=>{
    checkNetworkStatus();
    const storeid=data?._id;
    try{
      const response = await getStoreModules(storeid);
      setStoreModules(response?.results)
    }
    catch (error){
      handleError(error);
    }
  }

  const fetchiewMembersRef = useRef(fetcViewMembers);
  useEffect(() => {
    // fetchiewMembersRef.current();
    handleStoreModules();
    handleGetModules();
  }, []);

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal fade show d-block"
        id="ExpenseModal"
        tabIndex="-1"
        aria-labelledby="ExpenseModalLabel"
        aria-hidden="false"
        onClick={onClose}
      >
        <div
          className="modal-dialog modal-xl  modal-dialog-centered modal-dialog-scrollable "
          onClick={stopEventPropagation}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">
                <span
                  className={`badge rounded-pill ${
                    data?.stype ? getColor(data?.stype.toLowerCase()) : ""
                  }`}
                >
                  {data?.stype || "-"}
                </span>{" "}
                {" -"}{" "}
                <span className={`text-center ${getTextColor(data?.stype)}`}>
                  {data?.title || "-"}
                </span>{" -"}{" "}
                <span className={`text-center ${getTextColor(data?.stype)}`}>
                  {data?._id || "-"}
                </span>
              </h6>
              <CloseButton onClick={onClose} />
            </div>
            <div className="col-lg-12 mt-2">
              <ul className="nav nav-tabs custom-tabs">
                {[
                  // "dashboard",
                  "profile",
                  "module",
                  "settings"
                ].map((tab) => (
                  <li className="nav-item" key={tab}>
                    <button
                      className={`nav-link ${
                        activeTab === tab ? "active-tab" : ""
                      }`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {capitalizeFirstLetter(tab)}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div className="modal-body ">
              <div className="container px-0">
                <div className="main-body">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className=" mt-1 ">{renderContent()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer d-block">
              <CancelButton
                buttonText="Close"
                buttonIcon="bx bx-x"
                onClick={onClose}
                additionalClasses="btn-outline-secondary pull-right"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DashboardData = () => <div> Dashboard</div>;

export default ViewStore;
